import { Select, Spin } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getCookie } from "typescript-cookie";
import { EntInitialFilter } from "../../models/filters/initialFilter";
import { ISelectOption } from "../../models/utils/selectOption";
import { defaultFilterOption } from "../../utils";
import { useLazyGetPositionsListQuery } from "../../redux/api/handBooksApi/positionsApi";
import { useGetDataOnScroll } from "../getDataOnScrollProps/useGetDataOnScrollProps";
import { EntPositions } from "../../models/handBooks/positions";
import { EntInitialFilterName } from "../../models/filters/initialFilterName";

interface IProps {
    value?: number | null;
    onChange?: (e: any, a: any) => void;
    disabled?: boolean;
    departmentIds?: number[] | null
}

const SelectMultiPositions = (props: IProps) => {
    const { t } = useTranslation();
    const [options, setOptions] = useState<ISelectOption[]>([]);

    const [getData] = useLazyGetPositionsListQuery();
    const {
        fetching,
        data,
        setData,
        setFetching,
        setFilter,
        scrollHandler,
        setCurrentPage
    } = useGetDataOnScroll<EntPositions, EntInitialFilter>({
        initialFilter: new EntInitialFilter(),
        query: getData
    });

    useEffect(() => {
        if (props.departmentIds) {
            const filter = new EntInitialFilter();
            filter.departmentIds = props.departmentIds;
            setFilter(filter);
            setData([]);
            setCurrentPage(0);
            setFetching(true);
        } else {
            setOptions([]);
            setData([]);
        }
    }, [props.departmentIds]);

    useEffect(() => {
        const options = Array.from(new Set(data)).map((a) => {
            return { label: getCookie('i18next') === 'ky' ? `${a.nameKy}` : `${a.nameRu}` , value: a.id ?? '' };
        });
        setOptions(options);
    }, [data]);

    const search = (value?: string) => {
        if (!value) return;
        const filter = new EntInitialFilterName();
        filter.name = value;
        filter.departmentIds = props.departmentIds;
        setFilter(filter);
        setData([]);
        setCurrentPage(0);
        setFetching(true);
    }
    const clear = () => {
        const filter = new EntInitialFilterName();
        filter.name = null;
        filter.departmentIds = props.departmentIds;
        setFilter(filter);
        setData([]);
        setCurrentPage(0);
        setFetching(true);
    }

    return (
        <Select
          mode="multiple"
            disabled={ props.disabled }
            placeholder={t("msg.selectPlaceholder")}
            onClear={clear}
          onSearch={search}
            onPopupScroll={scrollHandler}
            loading={fetching}
            value={props.value}
            onChange={props.onChange}
            options={options}
            filterOption={defaultFilterOption}
            showSearch
            allowClear
            dropdownRender={(menu) => (
                <Spin spinning={fetching}>
                    {menu}
                </Spin>
            )}
        />
    );
};

export default SelectMultiPositions;